import { Component, OnInit } from '@angular/core';
import { AuthService } from '@core/auth.service';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-tester-events',
    templateUrl: './tester-events.component.html',
    styleUrls: ['./tester-events.component.scss'],
    standalone: true,
    imports: [
        IonicModule,
        RouterLink,
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        AsyncPipe,
    ],
})
export class TesterEventsComponent implements OnInit {
  panelOpenState = false
  testerEvent$ = this.authService.getEventsForTester();
  constructor(private authService: AuthService) {
  }

  ngOnInit() { }

}
